<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Xem chi tiết yêu cầu</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <!-- DAY_OFF -->
                    <div v-if="typeReq == 'DAY_OFF'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              clearable
                              filterable
                              v-model="mData.dataForm.detail_request.type"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listLoaiLyDoNghi"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Lý do">
                            <el-select
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col
                          md="12"
                          v-if="fn_shouldShowLegacySupervisorApproval()"
                        >
                          <el-form-item label="Phụ trách">
                            <el-select
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level1Approval
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <!-- table day off -->
                      <div
                        v-if="typeReq == 'DAY_OFF'"
                        class="
                          main-body-table
                          tableFixHead
                          table__shift-off
                          ml-3
                          mr-3
                        "
                      >
                        <table
                          class="table table-hover"
                          v-if="isHasDataTable == true"
                        >
                          <thead>
                            <tr>
                              <th class="tableTh sticky-col first-col" style="vertical-align: middle;z-index: 11;">Ngày</th>
                              <th
                                class="tableTh"
                                v-for="(item, i) in dataTableDate"
                                :key="i"
                              >
                                {{ item }}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(item, index) in dataTable"
                            :key="index"
                          >
                            <tr v-for="(row, index) in item" :key="index">
                              <td class="table__col-shiftName sticky-col first-col">
                                {{ row.shift_oddName }}
                              </td>
                              <td
                                v-for="(item, i) in row.date"
                                :key="i"
                                class="table__col-shiftOff"
                                max-height="50px"
                              >
                                <b-form-checkbox
                                  disabled
                                  class="disabled"
                                  v-if="item.value != null"
                                  value="1"
                                  unchecked-value="0"
                                  v-model="item.value"
                                >
                                  Nghỉ
                                </b-form-checkbox>
                                <p v-if="item.value == null" style="font-weight: bold; color: #FF0033">Ngày nghỉ</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- GO HOME EARLY-->
                    <div v-if="typeReq == 'COME_BACK_SOON'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Lý do">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col
                          md="12"
                          v-if="listEmployeeShiftDetail.length > 0"
                        >
                          <el-form-item label="Ca làm việc">
                            <el-radio-group
                              v-model="mData.dataForm.detail_request.shift_id"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-radio
                                class="mr-3"
                                v-for="(
                                  shift, index
                                ) in listEmployeeShiftDetail"
                                :key="index"
                                :label="shift.id"
                                >{{ shift.name }}</el-radio
                              >
                            </el-radio-group>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Thời gian về sớm">
                            <el-date-picker
                              type="datetime"
                              v-model="
                                mData.dataForm.detail_request.extra_minute
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="HH:mm dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- GO LATE-->
                    <div v-if="typeReq == 'GO_LATE'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Lý do">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col
                          md="12"
                          v-if="listEmployeeShiftDetail.length > 0"
                        >
                          <el-form-item label="Ca làm việc">
                            <el-radio-group
                              v-model="mData.dataForm.detail_request.shift_id"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-radio
                                class="mr-3"
                                v-for="(
                                  shift, index
                                ) in listEmployeeShiftDetail"
                                :key="index"
                                :label="shift.id"
                                >{{ shift.name }}</el-radio
                              >
                            </el-radio-group>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Thời gian đi muộn">
                            <el-date-picker
                              type="datetime"
                              v-model="
                                mData.dataForm.detail_request.extra_minute
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="HH:mm dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- GO ON BUSSINESS-->
                    <div v-if="typeReq == 'GO_ON_BUSSINESS'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col
                          md="12"
                          v-if="fn_shouldShowLegacySupervisorApproval()"
                        >
                          <el-form-item label="Phụ trách">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level1Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="6">
                          <el-form-item label="Thời gian từ">
                            <el-date-picker
                              type="date"
                              v-model="mData.dataForm.detail_request.start_date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="tới">
                            <el-date-picker
                              type="date"
                              v-model="mData.dataForm.detail_request.end_date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- GO OUT-->
                    <div v-if="typeReq == 'GO_OUT'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Lý do">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col
                          md="12"
                          v-if="listEmployeeShiftDetail.length > 0"
                        >
                          <el-form-item label="Ca làm việc">
                            <el-radio-group
                              v-model="mData.dataForm.detail_request.shift_id"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-radio
                                class="mr-3"
                                v-for="(
                                  shift, index
                                ) in listEmployeeShiftDetail"
                                :key="index"
                                :label="shift.id"
                                >{{ shift.name }}</el-radio
                              >
                            </el-radio-group>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="6">
                          <el-form-item label="Thời gian từ">
                            <el-date-picker
                              type="datetime"
                              v-model="mData.dataForm.detail_request.from_date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="HH:mm dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="tới">
                            <el-date-picker
                              type="datetime"
                              v-model="mData.dataForm.detail_request.to_date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="HH:mm dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- TIME KEEPING ONLINE-->
                    <div v-if="typeReq == 'TIME_KEEPING_ONLINE'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Phân loại"
                            prop="employee_request.type"
                          >
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ngày">
                            <el-date-picker
                              type="datetime"
                              v-model="mData.dataForm.detail_request.date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12" v-if="listEmployeeShiftDetail.length > 0">
                          <el-form-item
                            label="Ca làm việc"
                            prop="detail_request.shift_id"
                          >
                            <el-radio-group
                              v-model="mData.dataForm.detail_request.shift_id"
                              :disabled="
                                  mData.viewMode == 'detail' ||
                                  mData.viewMode == ''
                              "
                            >
                              <el-radio
                                class="mr-3"
                                v-for="(shift, index) in listEmployeeShiftDetail"
                                :key="index"
                                :label="shift.id"
                                >{{ shift.name }}</el-radio
                              >
                            </el-radio-group>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- WIFI_ATTENDANCE -->
                    <div v-if="typeReq == 'WIFI_ATTENDANCE'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Phân loại"
                            prop="employee_request.type"
                          >
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Thời gian điểm danh">
                            <el-input
                              :value="fn_getWifiAttendanceClock()"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ngày điểm danh">
                            <el-input
                              :value="fn_getWifiAttendanceDate()"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tên wifi">
                            <el-input
                              type="text"
                              :value="fn_getWifiAttendanceName()"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý trực tiếp">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.level2Approval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              :value="fn_getWifiAttendanceNote()"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- WORK ADDITION-->
                    <div v-if="typeReq == 'WORK_EXPLANATION'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Tiêu đề">
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Phân loại">
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Nhân viên">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Lý do">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Quản lý nhân sự">
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ngày">
                            <el-date-picker
                              type="date"
                              v-model="
                                mData.dataForm.detail_request
                                  .explained_start_date
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              format="dd/MM/yyyy"
                              prefix-icon="isax-calendar-1"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1" v-if="listEmployeeShiftDetail.length > 0">
                        <b-col md="12">
                          <el-form-item
                            label="Ca làm việc"
                            prop=""
                          >
                            <el-radio-group
                              v-model="mData.dataForm.detail_request.shift_id"
                            >
                              <el-radio
                                class="mr-3"
                                v-for="(
                                  shift, index
                                ) in listEmployeeShiftDetail"
                                :key="index"
                                :label="shift.id"
                                :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                                >{{ shift.name }}</el-radio
                              >
                            </el-radio-group>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Cách giải trình công"
                            prop=""
                          >
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.convert_work_method
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in listMethod"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="3" v-if="mData.dataForm.detail_request.convert_work_method == 'AUTO' && isPassDay">
                          <el-form-item
                            label="Thời gian bắt đầu"
                            prop=""
                          >
                            <el-date-picker
                              type="datetime"
                              v-model="mData.dataForm.detail_request.explained_start_date"
                              prefix-icon="isax-calendar-1"
                              :clearable="false"
                              format="HH:mm dd/MM/yyyy"
                              :picker-options="pickerOptionTo"
                              :disabled="!showReasonInput"
                              @change="fn_calWorkPassDayShift"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                        <b-col md="3" v-if="mData.dataForm.detail_request.convert_work_method == 'AUTO' && isPassDay">
                          <el-form-item
                            label="Thời gian kết thúc"
                            prop=""
                          >
                            <el-date-picker
                              type="datetime"
                              v-model="mData.dataForm.detail_request.explained_end_date"
                              prefix-icon="isax-calendar-1"
                              :clearable="false"
                              format="HH:mm dd/MM/yyyy"
                              :picker-options="pickerOptionTo"
                              :disabled="!showReasonInput"
                              @change="fn_calWorkPassDayShift"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                        <b-col md="6" v-if="mData.dataForm.detail_request.convert_work_method == 'AUTO' && !isPassDay">
                          <el-form-item label="Thời gian làm việc" prop="">
                            <el-time-picker
                              is-range
                              v-model="mData.dataForm.detail_request.time_work"
                              range-separator="_"
                              start-placeholder="Bắt đầu"
                              end-placeholder="kết thúc"
                              format="HH:mm"
                              :disabled="!showReasonInput"
                              prefix-icon="isax-calendar-1"
                              @change="fn_calWork"
                            >
                            </el-time-picker>
                          </el-form-item>
                        </b-col>
                        <b-col
                          :md="
                            mData.dataForm.detail_request.convert_work_method ==
                            'AUTO'
                              ? 6
                              : 12
                          "
                          v-if="mData.dataForm.detail_request.convert_work_method"
                        >
                          <el-form-item
                            label="Công"
                            :prop="mData.dataForm.detail_request.convert_work_method == 'INPUT' ? 'detail_request.number_of_works' : ''"
                          >
                            <el-input-number
                              type="number"
                              v-model="mData.dataForm.detail_request.number_of_works"
                              :disabled="
                                mData.dataForm.detail_request.convert_work_method == 'AUTO' || !showReasonInput
                              "
                              :precision="2"
                              :controls="false"
                            ></el-input-number>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item label="Ghi chú">
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- OT -->
                    <div v-if="typeReq == 'OT'">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Tiêu đề"
                            prop="employee_request.title"
                          >
                            <el-input
                              type="text"
                              v-model="mData.dataForm.employee_request.title"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              ref="title"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Phân loại"
                            prop="employee_request.type"
                          >
                            <el-select
                              disabled
                              clearable
                              filterable
                              v-model="mData.dataForm.employee_request.type"
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col class="md-4">
                          <el-form-item
                            label="Nhân viên"
                            prop="employee_request.employee_id"
                          >
                            <el-select
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employee_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in filteredRequestEmployees"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Lý do"
                            prop="detail_request.request_reason_id"
                          >
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.detail_request.request_reason_id
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listRequestReason"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col class="md-4">

                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col class="md-4">
                          <el-form-item
                            label="Quản lý nhân sự"
                            prop="employee_request.employeeApproval"
                          >
                            <el-select
                              clearable
                              filterable
                              v-model="
                                mData.dataForm.employee_request.employeeApproval
                              "
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            >
                              <el-option
                                v-for="item in mData.dataDefault
                                  .listEmployeeFromProfile"
                                :key="item.id"
                                :label="fn_setLabelRespectively(item)"
                                :value="item.id ? item.id : ''"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Ngày"
                            prop="detail_request.date"
                          >
                            <el-date-picker
                              type="date"
                              v-model="mData.dataForm.detail_request.date"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              placeholder=""
                              prefix-icon="isax-calendar-1"
                              :clearable="false"
                              format="dd/MM/yyyy"
                              :picker-options="pickerOptionFrom"
                            ></el-date-picker>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="6">
                          <el-form-item
                          label="Số giờ làm thêm"
                          prop="detail_request.ot_hours"
                        >
                          <el-input
                            type="number"
                            v-model.trim="
                              mData.dataForm.detail_request.ot_hours
                            "
                            :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            :precision="3"
                            :step="0.1"
                            :controls="false"
                          ></el-input>
                        </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item
                          label="Công"
                          prop="detail_request.work_value"
                        >
                          <el-input
                            type="number"
                            v-model.trim="
                              mData.dataForm.detail_request.work_value
                            "
                            :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                            :precision="3"
                            :step="0.1"
                            :controls="false"
                          ></el-input>
                        </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Ghi chú"
                            prop="employee_request.content"
                          >
                            <el-input
                              type="textarea"
                              v-model="mData.dataForm.employee_request.content"
                              :disabled="
                                mData.viewMode == 'detail' ||
                                mData.viewMode == ''
                              "
                              resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }"
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- Hủy request -->
                    <div v-if="cancelRequest == true">
                      <b-row class="mb-1">
                        <b-col md="12">
                          <el-form-item
                            label="Yêu cầu đã bị hủy bỏ"
                            class="cancel-reason-label"
                          >
                            <el-table :data="dataCancel" border style="width: 100%">
                              <el-table-column
                                prop="dataCancel"
                                label="Lý do hủy bỏ"
                                min-width="120"
                                align="center"
                              >
                                <template slot-scope="scope">
                                  <el-popover
                                    placement="top-start"
                                    trigger="hover"
                                    :open-delay="800"
                                    :content="scope.row.reasonCancellation"
                                  >
                                    <div class="content name" slot="reference">
                                      <span>{{ scope.row.reasonCancellation ? scope.row.reasonCancellation : '' }}</span>
                                    </div>
                                  </el-popover>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="timeCancel"
                                label="Thời gian"
                                align="center"
                                min-width="120"
                              >
                                <template slot-scope="scope">
                                  {{ scope.row.timeCancel }}
                                </template>
                              </el-table-column>
                            </el-table>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </div>
                    <!-- Table chi tiết các cấp duyệt -->
                    <div
                      class="main-body-table mb-3 ml-3 mr-3"
                      v-if="
                        cancelRequest != true &&
                        mData.dataForm.employee_request.type !=
                        'WORK_EXPLANATION' && dataRequest.length > 0
                      "
                    >
                      <el-table :data="dataRequest" border style="width: 100%">
                        <el-table-column prop="" label="STT" width="45">
                          <template slot-scope="scope">
                            <div class="text-center">
                              {{ scope.$index + 1 }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="name"
                          label="Tên quản lý"
                          min-width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="position_name"
                          label="Vai trò"
                          min-width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="is_approval"
                          align="center"
                          label="Trạng thái"
                          min-width="80"
                        >
                          <template slot-scope="scope">
                            <span
                              v-if="scope.row.is_approval == 'Đã duyệt'"
                              style="color: #00cc33"
                              >{{ scope.row.is_approval }}</span
                            >
                            <span
                              v-if="scope.row.is_approval == 'Từ chối'"
                              style="color: red"
                              >{{ scope.row.is_approval }}</span
                            >
                            <span
                              v-if="scope.row.is_approval == 'Chờ duyệt'"
                              style="color: black"
                              >{{ scope.row.is_approval }}</span
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="note"
                          label="Lý do từ chối"
                          min-width="150"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <el-popover
                              placement="top-start"
                              trigger="hover"
                              :open-delay="800"
                              :content="scope.row.note"
                            >
                              <div class="content name" slot="reference">
                                <span>{{ scope.row.note ? scope.row.note : '' }}</span>
                              </div>
                            </el-popover>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="approval_at"
                          label="Thời gian duyệt"
                          align="center"
                          min-width="120"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.approval_at }}
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- Button -->
                    <div class="text-center mt-2">
                      <!-- btn chỉnh sửa -->
                      <el-button
                        v-if="
                          mData.viewMode == 'detail' &&
                          showBtn &&
                          mData.dataForm.employee_request.type == 'WORK_EXPLANATION'
                        "
                        class="btn-update"
                        @click="handleUpdateClick()"
                        >
                        {{ showReasonInput ? 'Lưu' : 'Chỉnh sửa' }}
                      </el-button>
                      <!-- btn hủy -->
                      <el-button
                        v-if="
                          mData.viewMode == 'detail' &&
                          showBtn &&
                          mData.dataForm.employee_request.type == 'WORK_EXPLANATION' &&
                          showReasonInput
                        "
                        class="btn-default"
                        @click="handleCancelUpdate"
                        >Hủy bỏ</el-button
                      >
                      <!-- btn duyệt -->
                      <el-button
                        v-if="
                          mData.viewMode == 'detail' &&
                          showBtn &&
                          !showReasonInput
                        "
                        type="success"
                        round
                        @click="fn_submitForm('approve')"
                        >Duyệt</el-button
                      >
                      <!-- btn từ chối -->
                      <el-button
                        v-if="
                          mData.viewMode == 'detail' &&
                          showBtn &&
                          !showReasonInput
                        "
                        class="btn-default"
                        type="danger"
                        round
                        @click="dialogRejectRequest = true"
                        >Từ chối</el-button
                      >
                      <!-- btn hủy bỏ -->
                      <el-button
                        v-if="showBtnCancel"
                        class="btn-default"
                        type="danger"
                        round
                        @click="dialogCancelRequest = true"
                        >Hủy</el-button
                      >
                      <!-- btn quay lại -->
                      <el-button
                        v-if="
                          (mData.viewMode == 'detail' || mData.viewMode == '') &&
                          !showReasonInput
                        "
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Start dialog Reject sign -->
    <el-dialog
      class="dialog__reject-request"
      :visible.sync="dialogRejectRequest"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center mb-3">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.employee_request.title">
          Xác nhận Từ chối yêu cầu <br />
          "{{
            mData.dataForm.employee_request.title
          }}"
        </p>
      </div>
      <el-form
        ref="formRejectRequest"
        :model="mData.dataFormRejectRequest"
        :rules="mData.validFormRejectRequest"
        @submit.native.prevent
        label-position="top"
        style="width: 90%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item label="Lý do từ chối" prop="note">
              <el-input
                type="textarea"
                v-model="mData.dataFormRejectRequest.note"
                placeholder="Nhập nội dung"
                clearable
                show-word-limit
                maxlength="2000"
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogReject"
          class="btn-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitForm('disapprove')"
          class="btn-default"
          >Xác nhận</el-button
        >
      </span>
    </el-dialog>
    <!-- Start dialog cancel request -->
    <el-dialog
      class="dialog__cancel-request"
      :visible.sync="dialogCancelRequest"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center mb-3">
        <p class="dialog__text-warning font-xl" :title="mData.dataForm.employee_request.title">
          Xác nhận Hủy bỏ yêu cầu <br />
          "{{
            mData.dataForm.employee_request.title
          }}"
        </p>
      </div>
      <el-form
        ref="formCancelRequest"
        :model="mData.dataFormCancelRequest"
        :rules="mData.validFormCancelRequest"
        @submit.native.prevent
        label-position="top"
        style="width: 90%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item label="Lý do hủy bỏ" prop="note">
              <el-input
                type="textarea"
                v-model="mData.dataFormCancelRequest.note"
                placeholder="Nhập nội dung"
                clearable
                show-word-limit
                maxlength="2000"
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fn_closeDialogCancel"
          class="btn-back"
          >Đóng</el-button
        >
        <el-button
          @click="fn_submitForm('cancel')"
          class="btn-default"
          >Hủy bỏ</el-button
        >
      </span>
    </el-dialog>
    <!-- Dialog Lý do chỉnh sửa công -->
    <el-dialog
      class="dialog__reason-change"
      :visible.sync="dialogReasonChange"
      :show-close="false"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="text-center mb-3">
        <p class="dialog__text-warning font-xl">Lý do chỉnh sửa công</p>
      </div>
      <el-form
        ref="formReasonChange"
        :model="mData.dataForm.detail_request"
        :rules="reasonRules"
        @submit.native.prevent
        label-position="top"
        style="width: 90%; margin: 0 auto; border: none"
      >
        <b-row>
          <b-col>
            <el-form-item prop="reason_change">
              <el-input
                type="textarea"
                v-model="mData.dataForm.detail_request.reason_change"
                placeholder="Nhập lý do chỉnh sửa công"
                clearable
                resize="none"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleCancelReasonDialog"
          class="btn-back"
          >Hủy</el-button
        >
        <el-button
          @click="handleConfirmReasonChange"
          class="btn-default"
          >Xác Nhận</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import RequestReasonApi from "../../../../moduleApi/RequestReasonApi";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestDayOffApi from "../../../../moduleApi/EmployeeRequestDayOffApi";
import EmployeeRequestGoHomeEarlyApi from "../../../../moduleApi/EmployeeRequestGoHomeEarlyApi";
import EmployeeRequestGoLateApi from "../../../../moduleApi/EmployeeRequestGoLateApi";
import EmployeeRequestGoOnBussinessApi from "../../../../moduleApi/EmployeeRequestGoOnBussinessApi";
import EmployeeRequestGoOutApi from "../../../../moduleApi/EmployeeRequestGoOutApi";
import EmployeeRequestWorkAdditionApi from "../../../../moduleApi/EmployeeRequestWorkAdditionApi";
import EmployeeRequestTimeKeepingOnlineApi from "../../../../moduleApi/EmployeeRequestTimeKeepingOnlineApi";
import EmployeeRequestOTApi from "../../../../moduleApi/EmployeeRequestOTApi";
import AllowedIpApi from "../../../../moduleApi/AllowedIpApi";
import ShiftApi from "../../../../moduleApi/ShiftApi";
import EmployeeShiftApi from "../../../../moduleApi/EmployeeShiftApi";
import PositionApi from "../../../../moduleApi/PositionApi";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      mData: {
        viewMode: "",
        moduleName: "CheckRequest",
        dataDefault: {
          listEmployeeFromProfile: [],
          listFeature: MethodService.getListFeatures(),
          listAllowedIps: [],
        },
      },
      typeReq: "",
      dataDayOff: [],
      dataOffEachShift: [],
      dataTable: [],
      listShifts: [],
      isHasDataTable: false,
      listDayOffNotToReq: [],
      dataRequest: [],
      showBtn: false,
      number_of_works: 0,
      listMethod: [
        {
          label: "Nhập giờ để quy đổi ra công",
          value: "AUTO",
        },
        {
          label: "Nhập công",
          value: "INPUT",
        },
      ],
      isPassDay: false,
      numberWordDay: 0,
      dialogRejectRequest: false,
      cancelRequest: false,
      dataCancel:[],
      dialogCancelRequest: false,
      showBtnCancel: false,
      showReasonInput: false,
      originalNumberOfWorks: null,
      dialogReasonChange: false,
    };
  },
  computed: {
    reasonRules() {
      return {
        "reason_change": [
          {
            required: true,
            message: "Vui lòng nhập lý do chỉnh sửa công",
            trigger: ["blur", "change"],
          },
        ],
      };
    }
  },

  methods: {

    handleCancelUpdate() {
    this.showReasonInput = false;

    this.mData.dataForm.detail_request.number_of_works = this.originalNumberOfWorks;

    if (!this.mData.dataForm.detail_request.reason_change) {
      this.mData.dataForm.detail_request.reason_change = "";
    }

    this.$refs.form && this.$refs.form.clearValidate();
  },

    async handleUpdateClick() {
      if (!this.showReasonInput) {
        this.showReasonInput = true;
        if (this.mData.dataForm.detail_request.convert_work_method == 'AUTO' &&
            this.mData.dataForm.detail_request.explained_start_date) {
          const t = new Date(this.mData.dataForm.detail_request.explained_start_date);
          let todayShiftTime = [];
          this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
        }
        return;
      }
      this.$set(this.mData.dataForm.detail_request, 'reason_change', '');
      this.$nextTick(() => {
        this.$refs.formReasonChange && this.$refs.formReasonChange.clearValidate();
      });
      this.dialogReasonChange = true;
    },

    handleCancelReasonDialog() {
      this.dialogReasonChange = false;
    },

    async handleConfirmReasonChange() {
      this.$refs.formReasonChange.validate(async (valid) => {
        if (!valid) return;
        try {
          const detail = this.mData.dataForm.detail_request;
          const payload = {
            id: detail.id,
            reason_change: detail.reason_change,
            number_of_works: detail.number_of_works,
            explained_start_date: detail.explained_start_date,
            explained_end_date: detail.explained_end_date,
          };
          if (detail.convert_work_method == 'AUTO' && !this.isPassDay &&
              detail.time_work && detail.time_work[0] && detail.time_work[1]) {
            const t = new Date(detail.explained_start_date);
            const t1 = detail.time_work[0];
            const t2 = detail.time_work[1];
            payload.explained_start_date = new Date(
              t.getFullYear(), t.getMonth(), t.getDate(), t1.getHours(), t1.getMinutes()
            ).toISOString();
            payload.explained_end_date = new Date(
              t.getFullYear(), t.getMonth(), t.getDate(), t2.getHours(), t2.getMinutes()
            ).toISOString();
          }
          await EmployeeRequestWorkAdditionApi.update(payload);
          this.$message.success("Cập nhật thành công");
          this.dialogReasonChange = false;
          this.showReasonInput = false;
          this.originalNumberOfWorks = detail.number_of_works;
        } catch (error) {
          console.log(error);
          this.$message.error("Cập nhật thất bại");
        }
      });
    },

    fn_shouldShowLegacySupervisorApproval() {
      const employeeRequest =
        this.mData &&
        this.mData.dataForm &&
        this.mData.dataForm.employee_request
          ? this.mData.dataForm.employee_request
          : {};
      return Number(employeeRequest.approval_level) >= 3 || !!employeeRequest.level1Approval;
    },

    fn_getApprovalUserId(approvalUsers, index) {
      const approvalUser = approvalUsers && approvalUsers[index];
      return approvalUser && approvalUser.approval_user_id
        ? approvalUser.approval_user_id
        : undefined;
    },

    fn_getAllowedIpById(id) {
      if (!id) {
        return undefined;
      }
      return (this.mData.dataDefault.listAllowedIps || []).find(
        (item) => item.id == id
      );
    },

    fn_getWifiAttendanceContent() {
      const employeeRequest =
        this.mData &&
        this.mData.dataForm &&
        this.mData.dataForm.employee_request
          ? this.mData.dataForm.employee_request
          : {};
      if (!employeeRequest.content) {
        return {};
      }
      try {
        return JSON.parse(employeeRequest.content);
      } catch (error) {
        return {};
      }
    },

    fn_findAllowedIpForWifiAttendance() {
      const detailRequest = this.mData.dataForm.detail_request || {};
      const wifiContent = this.fn_getWifiAttendanceContent();
      const allowedIps = this.mData.dataDefault.listAllowedIps || [];
      const allowedIpById = detailRequest.allowed_ip_id
        ? this.fn_getAllowedIpById(detailRequest.allowed_ip_id)
        : undefined;
      const identifierCandidates = [
        allowedIpById && allowedIpById.ip_address
          ? allowedIpById.ip_address
          : "",
        wifiContent.bssid,
        wifiContent.ssid,
        detailRequest.ip_address,
        detailRequest.address,
      ].filter(Boolean);

      return allowedIps.find((item) =>
        identifierCandidates.some(
          (identifier) =>
            item &&
            item.ip_address &&
            item.ip_address.trim().toLowerCase() ===
              String(identifier).trim().toLowerCase()
        )
      );
    },

    fn_getWifiAttendanceName() {
      const detailRequest = this.mData.dataForm.detail_request || {};
      const wifiContent = this.fn_getWifiAttendanceContent();
      const allowedIp =
        this.fn_findAllowedIpForWifiAttendance() ||
        this.fn_getAllowedIpById(detailRequest.allowed_ip_id);
      return (
        (allowedIp && allowedIp.name) ||
        wifiContent.ssid ||
        detailRequest.name ||
        detailRequest.wifi_name ||
        ""
      );
    },

    fn_getWifiAttendanceAddress() {
      const detailRequest = this.mData.dataForm.detail_request || {};
      const wifiContent = this.fn_getWifiAttendanceContent();
      const allowedIp =
        this.fn_findAllowedIpForWifiAttendance() ||
        this.fn_getAllowedIpById(detailRequest.allowed_ip_id);
      return (
        (allowedIp && allowedIp.ip_address) ||
        wifiContent.bssid ||
        wifiContent.ssid ||
        detailRequest.ip_address ||
        detailRequest.address ||
        ""
      );
    },

    fn_getWifiAttendanceNote() {
      const wifiContent = this.fn_getWifiAttendanceContent();
      return wifiContent.note || "";
    },

    fn_getWifiAttendanceTime() {
      const createdAt =
        this.mData &&
        this.mData.dataForm &&
        this.mData.dataForm.employee_request
          ? this.mData.dataForm.employee_request.created_at
          : "";
      return createdAt ? MethodService.formatDate(createdAt, "datetime") : "";
    },

    fn_getWifiAttendanceDate() {
      const createdAt =
        this.mData &&
        this.mData.dataForm &&
        this.mData.dataForm.employee_request
          ? this.mData.dataForm.employee_request.created_at
          : "";
      return createdAt ? MethodService.formatDate(createdAt, "date") : "";
    },

    fn_getWifiAttendanceClock() {
      const createdAt =
        this.mData &&
        this.mData.dataForm &&
        this.mData.dataForm.employee_request
          ? this.mData.dataForm.employee_request.created_at
          : "";
      if (!createdAt) {
        return "";
      }
      const date = new Date(createdAt);
      const pad = (value) => String(value).padStart(2, "0");
      return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },

    async fn_innitDataDefault() {
      this.fn_getListEmployee();
      this.fn_getListEmployeeRequestReason();
      this.fn_getListAllowedIps();
    },

    async fn_getListEmployeeRequestReason() {
      const requestReasonApiRes = await RequestReasonApi.list({
        filters:
          "disabled!=true&company_id=" +
          this.currentCompany.id +
          "|company_id=",
        limit: 99999,
      });
      if (requestReasonApiRes.result && requestReasonApiRes.result.length > 0) {
        this.mData.dataDefault.listRequestReason = requestReasonApiRes.result;
      }
    },

    async fn_getListAllowedIps() {
      const allowedIpApiRes = await AllowedIpApi.list(
        {
          filters: "company_id=" + this.currentCompany.id,
          limit: 99999,
        },
        true
      );
      if (allowedIpApiRes.result && allowedIpApiRes.result.length > 0) {
        this.mData.dataDefault.listAllowedIps = allowedIpApiRes.result;
      } else {
        this.mData.dataDefault.listAllowedIps = [];
      }
    },

    async fn_getListEmployeeApproved(listIdEmployeeApproved) {
      const employeeApiRes = await EmployeeApi.list({
        filters: "company_id=" + this.currentCompany.id + "&id:in:" + listIdEmployeeApproved ,
        fields: "id,company_id,employee_no,administrative_info,job_info",
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployeeFromProfile =
          employeeApiRes.result.filter((item) => {
            if (item.id && item.company_id && item.employee_no && item.administrative_info) {
              return item;
            }
          });
        await this.fn_fillPositionName();
      }
    },

    async fn_fillPositionName() {
      let listPromise = [];
      this.mData.dataDefault.listEmployeeFromProfile.forEach((el) => {
        if (el.job_info && el.job_info.length > 0) {
          listPromise.push(this.fn_getListEmployeeApprovedPositionById(el.job_info[0].position_id));
        }
      });
      await Promise.all(listPromise)
      .then(val => {
        val.forEach((value, i) => {
          this.mData.dataDefault.listEmployeeFromProfile[i].position_name = value;
        })
      });
    },

    async fn_initDataShift() {
      // Lấy ra danh sách ngày nghỉ có phép ko phép ở màn DAY_OFF
      // this.fn_getEmployeeDayOff(
      //   this.mData.dataForm.employee_request.employee_id
      // );
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") +
          "employee_id=" +
          this.mData.dataForm.employee_request.employee_id,
        fields: "shift_id,start_time,end_time",
      };

      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        if (this.typeReq !== "DAY_OFF") {
          this.listShifts = MethodService.getValidShiftInfo(res.result);
          this.listShifts.reverse();
          this.listShifts = await this.fn_changeData(this.listShifts);
        }
        if (this.typeReq == "WORK_EXPLANATION") {
          const selectedShift = this.listEmployeeShiftDetail.find(o => o.id == this.mData.dataForm.detail_request.shift_id);
          if(selectedShift.is_pass_day) {
            this.isPassDay = true;
          }
        }
      }
    },

    async fn_checkValidShift() {
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") +
          (this.mData.dataForm.employee_request.employee_id
            ? "employee_id=" + this.mData.dataForm.employee_request.employee_id
            : ""),
        fields: "shift_id,start_time,end_time",
      };
      this.listShifts = []; //reset data
      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        const currentTime = new Date().getTime();
        const startTimeSelect = new Date(this.mData.dataForm.detail_request.start_date).getTime();
        const endTimeSelect = new Date(this.mData.dataForm.detail_request.end_date).getTime();
        res.result.forEach((el) => {
          if (el.start_time && el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            const endTime = new Date(el.end_time).getTime();
            if (
              (currentTime >= startTime && currentTime <= endTime) ||
              (startTimeSelect < startTime && endTimeSelect >= startTime) ||
              (startTimeSelect >= startTime && startTimeSelect <= endTime && endTimeSelect >= startTime) ||
              (startTimeSelect == endTime && endTimeSelect >= endTime)
            ) {
              this.listShifts.push(el);
            }
          } else if (el.start_time && !el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            if (
              currentTime >= startTime ||
              (startTimeSelect < startTime && endTimeSelect >= startTime) ||
              (startTimeSelect >= startTime && endTimeSelect >= startTime)
            ) {
              this.listShifts.push(el);
            }
          }
        });
        this.listShifts.reverse();
        this.listShifts = await this.fn_changeData(
          this.listShifts
        );
      }
    },

    // Xử lý dữ liệu ra Table chi tiết các cấp duyệt
    fn_changeDataTable(data) {
      data.forEach(el => {
        if (el.is_approval == true) {
          el.is_approval = "Đã duyệt";
        } else if (el.is_approval == false) {
          el.is_approval = "Từ chối";
        } else if (!el.is_approval) {
          el.is_approval = "Chờ duyệt";
        }
        if (el.approval_at) {
          el.approval_at = MethodService.formatDate(el.approval_at, "datetime");
        } else if (!el.approval_at) {
          el.approval_at = "";
        }
        const o = this.mData.dataDefault.listEmployeeFromProfile.find((e) => e.id == el.approval_user_id);
        el.name = o ? o.administrative_info.name.full_name : '';
        el.position_name = o ? o.position_name: '';
      });
      return data;
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let shiftIds = [];
      shiftIds = MethodService.findListItemDifferent(resData, "shift_id");
      const shiftApiRes = await ShiftApi.list({
        limit: shiftIds.length,
        filters: "id:in:" + shiftIds.join(","),
      });
      this.listEmployeeShiftDetail = shiftApiRes.result;
      if (this.listEmployeeShiftDetail.length > 0) {
        resData.forEach((item) => {
          if (item.start_time && item.end_time) {
            item.start_time = MethodService.formatDate(item.start_time, "date");
            item.end_time = MethodService.formatDate(item.end_time, "date");
            let caLamViec = this.listEmployeeShiftDetail.find((element) => {
              return element.id == item.shift_id;
            });
            item.work_days = caLamViec.work_days;
            if (caLamViec) {
              if (caLamViec.is_odd_shift) {
                let shiftOddNames = caLamViec.odd_names.map((el) => {
                  return el + " (" + caLamViec.name + ")";
                });
                item.ten_ca = shiftOddNames;
              } else {
                item.ten_ca = [caLamViec.name];
              }
            } else {
              item.ten_ca = "";
            }
          } else if (item.start_time && !item.end_time) {
            item.start_time = MethodService.formatDate(item.start_time, "date");
            let caLamViec = this.listEmployeeShiftDetail.find((element) => {
              return element.id == item.shift_id;
            });
            item.work_days = caLamViec.work_days;
            if (caLamViec) {
              if (caLamViec.is_odd_shift) {
                let shiftOddNames = caLamViec.odd_names.map((el) => {
                  return el + " (" + caLamViec.name + ")";
                });
                item.ten_ca = shiftOddNames;
              } else {
                item.ten_ca = [caLamViec.name];
              }
            } else {
              item.ten_ca = "";
            }
          }
        });
        return resData;
      } else {
        resData = [];
        return resData;
      }
    },

    // Use to render table DayOff
    async fn_tableSearch() {
      // Check to get start date and end date request off
      let arrDay = []
      this.dataOffEachShift.forEach(item => {
        item.forEach(dataDayOff => {
          arrDay.push(new Date(dataDayOff.day).getTime())
        })
      });
      let startDate = new Date(Math.min(...arrDay));
      let endDate =  new Date(Math.max(...arrDay));

      this.listDate = this.fn_getListDate(startDate, endDate);
      await this.fn_checkValidShift();
      if (this.listShifts.length > 0) {
        this.dataTable = await this.buildDataTable(
          this.listShifts,
          this.listDate
        );
      }
      this.fn_setHeaderTable(this.dataTable);
      if (this.dataTable != null) {
        this.isHasDataTable = true;
        await this.fn_setValTable();
      }
    },

    fn_checkShiftIteration(day, shiftWordDay) {
      const iteration = shiftWordDay && shiftWordDay.iteration_cycle
        ? shiftWordDay.iteration_cycle
        : "";
      const weekNumOfYear = this.fn_getWeekNumOfYear(day);
      const weekNumOfMonth = this.fn_getWeekNumOfMonth(day);
      const lastWeekNum = this.fn_getWeekNumOfMonth(
        new Date(new Date(day).getFullYear(), new Date(day).getMonth() + 1, 0)
      );
      const nearLastWeekNum =
        this.fn_getWeekNumOfMonth(
          new Date(new Date(day).getFullYear(), new Date(day).getMonth() + 1, 0)
        ) - 1;
      if (
        shiftWordDay && shiftWordDay.number_word_day &&
        iteration == "WEEKLY" ||
        (iteration == "EVEN_WEEK_OF_MONTH" && weekNumOfYear % 2 == 0) ||
        (iteration == "ODD_WEEK_OF_MONTH" && weekNumOfYear % 2 != 0) ||
        (iteration == "WEEK_1_OF_MONTH" && weekNumOfMonth == 1) ||
        (iteration == "WEEK_2_OF_MONTH" && weekNumOfMonth == 2) ||
        (iteration == "WEEK_3_OF_MONTH" && weekNumOfMonth == 3) ||
        (iteration == "WEEK_4_OF_MONTH" && weekNumOfMonth == 4) ||
        (iteration == "WEEK_5_OF_MONTH" && weekNumOfMonth == 5) ||
        (iteration == "NEAR_LAST_WEEK_OF_MONTH" && weekNumOfMonth == nearLastWeekNum) ||
        (iteration == "LAST_WEEK_OF_MONTH" && weekNumOfMonth == lastWeekNum)
      ) {
        return true;
      } else {
        return false;
      }
    },

    buildDataTable(listShift, listDay, listDayOff = []) {
      let dataTable = [];
      if (!listShift || !listDay) {
        return dataTable;
      }
      dataTable = listShift.map((shift) => {
        let listItem = [];
        for (let i = 0; i < shift.ten_ca.length; i++) {
          let item = {
            shift_id: shift.shift_id,
            shift_oddName: shift.ten_ca[i],
          };
          listItem.push(item);
        }
        for (let i = 0; i < listItem.length; i++) {
          listItem[i].date = [];
          listDay.forEach((day) => {
            const dayOfWeek = day.getDay() == 0 ? "8" : day.getDay() + 1;
            const shiftWordDay = shift.work_days.find(e => e.name == dayOfWeek); // Get periodTime of day
            const flag = this.fn_checkShiftIteration(day, shiftWordDay);
            let periodTime = [
              { start_time: {}, end_time: {} },
              { start_time: {}, end_time: {} },
            ];
            if (shiftWordDay && flag) {
              periodTime = shiftWordDay.period_time;
            }
            this.fn_setValueDefaultTable(shift, day, periodTime, listDay, listItem[i]);
          });
        }
        return listItem;
      });
      return dataTable;
    },

    fn_setValueDefaultTable(shift, day, periodTime, listDay, itemOfList) {
      let dayFormatted = MethodService.formatDate(day, "date");
      let value = null;
      let eachDay = new Date(day).getTime();

      if (shift.start_time && shift.end_time) {
        let d_startLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.start_time)
        ).getTime();
        let d_endLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.end_time)
        ).getTime();
        if (shift.ten_ca.length == 1) {
          const hasStartTimeShift = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift = Object.keys(periodTime[0].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (
              eachDay >= d_startLimit && eachDay <= d_endLimit &&
              hasStartTimeShift !== 0 && hasEndTimeShift !== 0
            ) {
              value = 0; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        } else if (shift.ten_ca.length == 2) {
          const hasStartTimeShift1 = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift1 = Object.keys(periodTime[0].end_time).length;
          const hasStartTimeShift2 = Object.keys(periodTime[1].start_time).length;
          const hasEndTimeShift2 = Object.keys(periodTime[1].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (eachDay >= d_startLimit && eachDay <= d_endLimit && hasStartTimeShift1 !== 0 && hasEndTimeShift1 !== 0 && hasStartTimeShift2 !== 0 && hasEndTimeShift2 !== 0) {
              value = 0; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        }
      } else if (shift.start_time && !shift.end_time) {
        let d_startLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.start_time)
        ).getTime();
        if (shift.ten_ca.length == 1) {
          const hasStartTimeShift = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift = Object.keys(periodTime[0].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (eachDay >= d_startLimit && hasStartTimeShift !== 0 && hasEndTimeShift !== 0) {
              value = 0; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        } else if (shift.ten_ca.length == 2) {
          const hasStartTimeShift1 = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift1 = Object.keys(periodTime[0].end_time).length;
          const hasStartTimeShift2 = Object.keys(periodTime[1].start_time).length;
          const hasEndTimeShift2 = Object.keys(periodTime[1].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (eachDay >= d_startLimit && hasStartTimeShift1 !== 0 && hasEndTimeShift1 !== 0 && hasStartTimeShift2 !== 0 && hasEndTimeShift2 !== 0) {
              value = 0; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        }
      }
      let o = { day: dayFormatted, value };
      itemOfList.date.push(o);
    },

    fn_checkDuplicateHoliday(dataTable) {
      dataTable.forEach((item) => {
        let dayConsider; //ngày xét có trùng ngày nghỉ quốc tế không
        for (let i = 0; i < item.length; i++) {
          for (let j = 0; j < item[i].date.length; j++) {
            for (let z = 0; z < this.listDayOffNotToReq.length; z++) {
              dayConsider = item[i].date[j].day.includes(
                this.listDayOffNotToReq[z]
              );
              if (dayConsider) {
                item[i].date[j].value = null; // trùng thì xét giá trị "null" và không sinh ra ô xin nghỉ
              }
            }
          }
        }
      });
    },

    async fn_innitDataForm() {
      await this.fn_getDataById(this.mData.id);
      await this.fn_initDataShift();
      if (this.typeReq == "DAY_OFF") {
        await this.fn_tableSearch();
      }
    },

    async fn_getListEmployeeApprovedPositionById(id) {
      if (!id) {
        return undefined;
      }
      const positionApiRes = await PositionApi.findById(id);
      if (positionApiRes.result) {
        return positionApiRes.result.name;
      }
    },

    async fn_getDataById(id) {
      const _this = this.mData.dataForm;
      const employeeRequestApiRes = await EmployeeRequestApi.findById(id);
      if (employeeRequestApiRes.result) {
        _this.employee_request.employee_id = employeeRequestApiRes.result.id;
        _this.employee_request = employeeRequestApiRes.result;
        _this.employee_request.reason_change = employeeRequestApiRes.result.reason_change;
        this.typeReq = employeeRequestApiRes.result.type;
        this.cancelRequest = employeeRequestApiRes.result.cancel_request;
        const reasonCancellation = employeeRequestApiRes.result.reason_cancellation;
        const timeCancel = employeeRequestApiRes.result.time_cancel ?  MethodService.formatDate(employeeRequestApiRes.result.time_cancel, "datetime") : "";
        this.dataCancel = [];
        this.dataCancel.push({
          reasonCancellation: reasonCancellation,
          timeCancel: timeCancel,
        })

        this.showBtnCancel = false;
        if(
          this.cancelRequest != true 
          && _this.employee_request.employee_id === this.currentUser.id  
          && ["WAITING_FOR_APPROVAL", "APPROVED"].includes(
            _this.employee_request.status
          )
        )
        {
          this.showBtnCancel = true;
        }


        if (
          _this.employee_request.status == "APPROVED" ||
          _this.employee_request.status == "REJECTED"
        ) {
          this.mData.viewMode = "";
        } else {
          this.mData.viewMode = "detail";
        }

        const approvalUsers = employeeRequestApiRes.result.approval_users || [];
        let listIdEmployeeApproved = [];
        if (_this.employee_request.approval_level == 1) {
          _this.employee_request.employeeApproval =
            this.fn_getApprovalUserId(approvalUsers, 0);
          listIdEmployeeApproved = [
            _this.employee_request.employee_id,
            _this.employee_request.employeeApproval
          ]
        } else if (_this.employee_request.approval_level == 2) {
          _this.employee_request.level2Approval =
            this.fn_getApprovalUserId(approvalUsers, 0);
          _this.employee_request.employeeApproval =
            this.fn_getApprovalUserId(approvalUsers, 1);
          listIdEmployeeApproved = [
            _this.employee_request.employee_id,
            _this.employee_request.level2Approval,
            _this.employee_request.employeeApproval
          ]
        } else if (_this.employee_request.approval_level == 3) {
          _this.employee_request.level1Approval =
            this.fn_getApprovalUserId(approvalUsers, 0);
          _this.employee_request.level2Approval =
            this.fn_getApprovalUserId(approvalUsers, 1);
          _this.employee_request.employeeApproval =
            this.fn_getApprovalUserId(approvalUsers, 2);
          listIdEmployeeApproved = [
            _this.employee_request.employee_id,
            _this.employee_request.level1Approval,
            _this.employee_request.level2Approval,
            _this.employee_request.employeeApproval
          ]
        }

        await this.fn_getListEmployeeApproved(
          listIdEmployeeApproved.filter((item) => !!item)
        );

        if (this.typeReq == "DAY_OFF") {
          const employeeRequestDayOffApiApiRes =
            await EmployeeRequestDayOffApi.findById(id);
            if (employeeRequestDayOffApiApiRes.result) {
              _this.detail_request = employeeRequestDayOffApiApiRes.result;
              this.dataDayOff = _this.detail_request.dayoff_time;
               // Get Min date
               this.mData.dataForm.detail_request.start_date = new Date(
                Math.min(
                  ...this.dataDayOff.map(element => {
                    return new Date(element.day);
                  }),
                ),
              );
              // Get Max date
              this.mData.dataForm.detail_request.end_date = new Date(
                Math.max(
                  ...this.dataDayOff.map(element => {
                    return new Date(element.day);
                  }),
                ),
              );

              await this.fn_getDataOffEachShift();
              this.fn_getListHoliday();
            }
        } else if (this.typeReq == "COME_BACK_SOON") {
          const employeeRequestGoHomeEarlyApiRes =
            await EmployeeRequestGoHomeEarlyApi.findById(id);
          _this.detail_request = employeeRequestGoHomeEarlyApiRes.result;
        } else if (this.typeReq == "GO_LATE") {
          const employeeRequestGoLateApiRes =
            await EmployeeRequestGoLateApi.findById(id);
          _this.detail_request = employeeRequestGoLateApiRes.result;
        } else if (this.typeReq == "GO_ON_BUSSINESS") {
          const employeeRequestGoOnBussinessApiRes =
            await EmployeeRequestGoOnBussinessApi.findById(id);
          _this.detail_request = employeeRequestGoOnBussinessApiRes.result;
        } else if (this.typeReq == "GO_OUT") {
          const employeeRequestGoOutApiRes =
            await EmployeeRequestGoOutApi.findById(id);
          _this.detail_request = employeeRequestGoOutApiRes.result;
        } else if (this.typeReq == "WORK_EXPLANATION") {
          const employeeRequestWorkAdditionApiRes =
            await EmployeeRequestWorkAdditionApi.findById(id);
          _this.detail_request = employeeRequestWorkAdditionApiRes.result;
          this.originalNumberOfWorks = _this.detail_request.number_of_works;
          if (employeeRequestWorkAdditionApiRes.result.convert_work_method == "AUTO" && !this.isPassDay) {
            this.$set(this.mData.dataForm.detail_request, 'time_work', [
              new Date(employeeRequestWorkAdditionApiRes.result.explained_start_date),
              new Date(employeeRequestWorkAdditionApiRes.result.explained_end_date),
            ]);
          }
        } else if (this.typeReq == "TIME_KEEPING_ONLINE") {
          const employeeRequestTimeKeepingOnlineApiApiRes =
            await EmployeeRequestTimeKeepingOnlineApi.findById(id);
          _this.detail_request = employeeRequestTimeKeepingOnlineApiApiRes.result;
        }  else if (this.typeReq == "OT") {
          const employeeRequestOTApiRes = await EmployeeRequestOTApi.findById(id);
          _this.detail_request = employeeRequestOTApiRes.result;
        }

        this.dataRequest = await this.fn_changeDataTable(employeeRequestApiRes.result.approval_users);
        await this.fn_checkToShowBtn(this.dataRequest);
      }
    },

    fn_checkToShowBtn(dataRequest) {
      this.showBtn = false;
      var index = dataRequest.findIndex(e => e.approval_user_id == this.currentUser.id && e.is_approval == "Chờ duyệt");
      if(index == 0) {
        this.showBtn = true;
      }
      else if(index > 0) {
        if (dataRequest[index - 1].is_approval == "Đã duyệt") {
          this.showBtn = true;
        }
      }
    },

    fn_getDataOffEachShift() {
      let dataFilter;
      for (let i = 0; i < this.dataDayOff.length; i++) {
        dataFilter = this.dataDayOff.filter(
          (o) => o.shift_id == this.dataDayOff[i].shift_id
        );
        this.dataOffEachShift.push(dataFilter);
      }
    },

    fn_setValTable() {
      this.dataTable.forEach((shift) => {
        shift.forEach((shiftDetail, index) => {
          shiftDetail.date.forEach((d) => {
            this.convertDayFromApi(d, shiftDetail.shift_id, index);
          });
        });
      });
    },

    convertDayFromApi(date, shiftId = "", index = 0) {
      let newDate = date;
      this.dataOffEachShift.forEach((shiftApi) => {
        shiftApi.forEach((data) => {
          if (
            newDate.day === MethodService.formatDate(data.day, "date") &&
            shiftId === data.shift_id
          ) {
            if (newDate.value != null) {
              newDate.value = data.odd_shifts[index];
            }
          }
        });
      });
      if (this.listDayOffNotToReq.includes(date.day)) {
        date.value = null;
      }
      return newDate;
    },
    //Form
    async fn_submitForm(type) {
      if (type == "approve") {
        try {
          await EmployeeRequestApi.AppovalRequest({ id: this.mData.id });
          await this.fn_getDataById(this.mData.id);
          window.toastr.success("Duyệt yêu cầu thành công !");
        } catch (error) {
          const message = error && error.meta ? error.meta.field : "Có lỗi xảy ra";
          window.toastr.error(message);
          if (message == "Người tạo đã hủy đơn") {
            await this.fn_getDataById(this.mData.id);
          }
        }
      } else if (type == "disapprove") {
        this.$refs["formRejectRequest"].validate(async (valid) => {
          if (!valid) return false;
          try {
            await EmployeeRequestApi.UnAppovalRequest({ id: this.mData.id, note: this.mData.dataFormRejectRequest.note ? this.mData.dataFormRejectRequest.note.trim() : '' });
            await this.fn_getDataById(this.mData.id);
            window.toastr.success("Từ chối yêu cầu thành công !");
            await this.fn_closeDialogReject();
            this.dialogRejectRequest = false;
          } catch (error) {
            const message = error && error.meta ? error.meta.field : "Có lỗi xảy ra";
            window.toastr.error(message);
            if (message == "Người tạo đã hủy đơn") {
              await this.fn_closeDialogReject();
              this.dialogRejectRequest = false;
              await this.fn_getDataById(this.mData.id);
            }
          }
        });
      } else if (type == "cancel") {
        this.$refs["formCancelRequest"].validate(async (valid) =>{
          if (!valid) return false;
          try{
            await EmployeeRequestApi.CancelRequest(
              { id: this.mData.id, note: this.mData.dataFormCancelRequest.note ? this.mData.dataFormCancelRequest.note.trim() : '' }
            );
            await this.fn_getDataById(this.mData.id);
            window.toastr.success("Hủy bỏ yêu cầu thành công !");
            await this.fn_closeDialogCancel();
            this.dialogCancelRequest = false;
          }catch (error){
            window.toastr.error(error.meta.field);
          }
        })
      }
    },
  },

   created() {
    this.mData.id = this.$router.currentRoute.params.id;
    this.fn_innitDataDefault();
    this.fn_innitDataForm();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css"></style>
